export default class IDB {
  // 已打开的DB无需重复打开
  static DB_MAP = {}
  // 缓存相同db和store的 idb 实例，减少内存占用
  static IDB_MAP = {}

  db = null
  dbName = ''
  storeName = ''
  version
  onUpgrade
  onError
  dbMapKey = ''
  idbMapKey = ''

  constructor(dbName, storeName, events, version) {
    // 根据dbName和storeName唯一确定一个单例
    this.dbMapKey = `${dbName}_${version || 1}`
    this.idbMapKey = `${dbName}_${storeName}`
    if (IDB.IDB_MAP[this.idbMapKey]) {
      return IDB.IDB_MAP[this.idbMapKey]
    }
    IDB.IDB_MAP[this.idbMapKey] = this

    this.dbName = dbName
    this.storeName = storeName
    this.onUpgrade = events.onUpgrade
    this.onError = events.onError
    this.version = version
  }

  async openDB() {
    const { dbName, version, onUpgrade, onError } = this
    if (IDB.DB_MAP[this.dbMapKey]) {
      return IDB.DB_MAP[this.dbMapKey]
    }

    return new Promise((resolve, reject) => {
      const request = indexedDB.open(dbName, version)
      request.onerror = (e) => {
        console.error(e)
        reject(e)
      }
      request.onblocked = (e) => {
        console.error(e)
        reject(e)
      }
      request.onupgradeneeded = (e) => {
        onUpgrade(request.result, e)
      }
      request.onsuccess = () => {
        const db = request.result
        this.db = IDB.DB_MAP[this.dbMapKey] = db
        db.onerror = (e) => {
          onError?.(e)
          console.error(e)
        }
        db.onversionchange = () => {
          db.close()
          this.db = null
          delete IDB.DB_MAP[this.dbMapKey]
        }
        resolve(db)
      }
    })
  }

  async removeDB() {
    const request = indexedDB.deleteDatabase(this.dbName)
    return new Promise((resolve, reject) => {
      request.onerror = (e) => {
        console.error(e)
        reject(e)
      }
      request.onblocked = (e) => {
        console.error(e)
        reject(e)
      }
      request.onsuccess = () => {
        resolve(true)
      }
    })
  }

  async transactionAction(action, mode) {
    if (!this.db) {
      this.db = await this.openDB()
    }
    const store = this.db
      .transaction(this.storeName, mode)
      .objectStore(this.storeName)
    return new Promise((resolve, reject) => {
      const request = action(store)
      request.onerror = reject
      request.onsuccess = () => resolve(request.result)
    })
  }

  getData(key) {
    return this.transactionAction((store) => store.get(key))
  }

  addData(value, key) {
    return this.transactionAction((store) => store.add(value, key), 'readwrite')
  }

  setData(value, key) {
    return this.transactionAction((store) => store.put(value, key), 'readwrite')
  }

  deleteData(key) {
    return this.transactionAction((store) => store.delete(key), 'readwrite')
  }

  clearData() {
    return this.transactionAction((store) => store.clear(), 'readwrite')
  }
}
